import {combineReducers} from 'redux-loop';
import educacionReducer from './todo-reducer';

const allReducers = combineReducers({
	educacionReducer
});	

export default allReducers;


// WEBPACK FOOTER //
// ./src/reducer/index.js